import { render, staticRenderFns } from "./JSelectUserByDepModal.vue?vue&type=template&id=4973756a&scoped=true"
import script from "./JSelectUserByDepModal.vue?vue&type=script&lang=js"
export * from "./JSelectUserByDepModal.vue?vue&type=script&lang=js"
import style0 from "./JSelectUserByDepModal.vue?vue&type=style&index=0&id=4973756a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@7.1.2_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4973756a",
  null
  
)

export default component.exports